import lightGallery from 'lightgallery';

// Plugins
// import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'
import lgFullscreen from 'lightgallery/plugins/fullscreen'


// Add your JS customizations here
jQuery(document).ready(function ($) {

/******************************************
	Variables
******************************************/

	var body = $("body");



/******************************************
	General features
******************************************/





/******************************************
	Page scroll
******************************************/

function scroll_page() {
	var scroll = $(window).scrollTop();
	var documentHeight = $(document).height();
	var windowHeight = $(window).height();
	var footerHeight = $('.wrapper-footer').outerHeight();
	var navHeight = $('.container-work-footer').outerHeight();

	var footerTrigger = documentHeight - (windowHeight + footerHeight);

	// Add class when scroll
	if (scroll >= 125) {
		$("body").addClass("window-scroll");
	} else {
		$("body").removeClass("window-scroll");
	}

	// Add class when reach footer
	if ( scroll >= footerTrigger) {
		$("body").addClass("footer-reach");
		$('.container-work-footer.on-page').addClass('be-sticky');
	} else {
		$("body").removeClass("footer-reach");
		$('.container-work-footer.on-page').removeClass('be-sticky');
	}



}
$(window).on("scroll", scroll_page);



/******************************************
	Homepage
******************************************/

function home_open_img(){
	body.addClass('home-column-open');
}
$('.home-col-01-hover .home-col-01-up').on('mouseover', home_open_img);

function home_close_img(){
	body.removeClass('home-column-open');
}
$('.home-col-01-hover .home-col-01-up').on('mouseleave', home_close_img);




/******************************************
	Footer
	Newsletter form
******************************************/

function newsletter_form_toggler(){
	$(".container-newsletter-footer").fadeToggle();
}
$('#newsletter-footer-toggler').on('click', newsletter_form_toggler);



/******************************************
	Collapse newsletter footer animation
******************************************/


$('#collapse-footer').on('show.bs.collapse', function () {
	var documentHeight = $(document).height();
	var windowHeight = $(window).height();
	var footerHeight = $('.wrapper-footer').outerHeight();
	var footerTrigger = documentHeight - (windowHeight + footerHeight);

    $('html,body').animate({ scrollTop: documentHeight }, 250);
})



/******************************************
	Work archive
	Masonry layout
******************************************/

var first_visit = true;

var grid_work = $('.row-archive-work').masonry({
  // options
  itemSelector: '.col-work',
  percentPosition: true,
  transitionDuration: '0.8s',
  horizontalOrder: true
});

document.addEventListener('facetwp-loaded', function() {
	grid_work.masonry('reloadItems')
	grid_work.masonry('layout');

	if(!first_visit){
		$(window).scrollTop(100);
		$('html, body').animate({
			scrollTop: 0
		}, 600);

		setTimeout(function(){
			AOS.refreshHard();
		}, 1000);
	}
	first_visit = false;
});



function work_filters_toggler(){
	$('.archive-filters-wraper').fadeToggle();
}
$('#work-filter-toggler').on('click', work_filters_toggler);





/******************************************
	Work archive
	Change work name in navbar footer
******************************************/

if(body.hasClass('post-type-archive-work')){

	function change_work_title_name(){
		var pos = $(window).scrollTop() + ($(window).height() / 2);


		if($('.col-title-left').is(':visible')){

			$('.work-column-1').each(function() {
				var sectionName;
				var item_ID = $(this).data('id');
				var height = $(this).height();
				var el_top = $(this).offset().top;

				if (pos >= el_top && pos <= el_top + height && actual_ID_01 != item_ID) {
					sectionName = $(this).data('title');
					actual_ID_01 = item_ID;

					title_01.stop().animate({'opacity': 0}, 400, function () {
				    	$(this).text(sectionName).animate({'opacity': 1}, 400);
					});
				}
			});

			$('.work-column-2').each(function() {
				var sectionName;
				var item_ID = $(this).data('id');
				var height = $(this).height();
				var el_top = $(this).offset().top;

				if (pos >= el_top && pos <= el_top + height && actual_ID_02 != item_ID) {
					sectionName = $(this).data('title');
					actual_ID_02 = item_ID;

					title_02.stop().animate({'opacity': 0}, 400, function () {
				    	$(this).text(sectionName).animate({'opacity': 1}, 400);
					});
				}
			});
		}

		/*Mobile*/
		if($('.col-title-mobile').is(':visible')){

			$('.col-work article').each(function() {

				var sectionName;
				var item_ID = $(this).data('id');
				var height = $(this).height();
				var el_top = $(this).offset().top;

				if (pos >= el_top && pos <= (el_top + height) && actual_ID_mobile != item_ID) {

					sectionName = $(this).data('title');
					actual_ID_mobile = item_ID;

					title_mobile.stop().animate({'opacity': 0}, 400, function () {
				    	$(this).text(sectionName).animate({'opacity': 1}, 400);
					});
				}
			});
		}
	}
	$(window).on('scroll resize', change_work_title_name);


	var title_01 = $('.work-title.left');
	var title_02 = $('.work-title.right');
	var title_mobile = $('.work-title.mobile');

	var actual_ID_01, actual_ID_02, actual_ID_mobile;

	function work_first_title(){

		var first_title_col01 = $('article.work-column-1:eq( 0 )').data('title');
		var first_ID_col01 = $('article.work-column-1:eq( 0 )').data('id');
		actual_ID_01 = first_ID_col01;
		title_01.text(first_title_col01);

		var first_title_col02 = $('article.work-column-2:eq( 0 )').data('title');
		var first_ID_col02 = $('article.work-column-2:eq( 0 )').data('id');
		actual_ID_02 = first_ID_col02;
		title_02.text(first_title_col02);

		var first_title_col_mobile = $('.col-work article:eq( 0 )').data('title');
		var first_ID_col_mobile = $('.col-work article:eq( 0 )').data('id');
		actual_ID_mobile = first_ID_col_mobile;
		title_mobile.text(first_title_col_mobile);
	}
	work_first_title();

	function toggle_work_grid(){
		var clicked = $(this).data('layout');
		$('.layout-option').removeClass('selected');

		if( $(this).hasClass('grid') ){
			$('.grid').addClass('selected');
		}else{
			$('.stack').addClass('selected');
		}

		body.removeClass('work-grid work-stack').addClass(clicked);
		grid_work.masonry('layout');
		$(window).scrollTop(100);

		$('html, body').animate({
            scrollTop: 0
        }, 600);
	}
	$('.layout-option').on('click', toggle_work_grid)

}




/******************************************
	Navigation
******************************************/

$(".menu-icon").on("click", function () {
	if( body.hasClass('main-menu-open') ){
		body.removeClass("main-menu-open no-overflow");
		$('#menu-main-wrapper').fadeOut();
		$(".work-list-item").removeClass('show');
	}else{
		body.addClass("main-menu-open no-overflow");
		$('#menu-main-wrapper').fadeIn();
		body.removeClass("work-form-toggler-open work-form-mobile-toggler-open");

		$(".works-item-scroll .work-list-item").each(function(i) {
    		var el = $(this);
    		setTimeout(function() {
				el.addClass('show');
    		}, i * 200);
		});

	}
});








/******************************************
	Single Work
******************************************/


function work_info_toggler(){
	body.removeClass("work-form-toggler-open");
	body.toggleClass("work-swiper-wraper-open");
}
$('#work-controler-info').on('click', work_info_toggler);

function work_swiper_context_toggler(){
	body.toggleClass("swiper-work-context-show");

	if(swiper_work_01.autoplay.running){
		swiper_work_01.autoplay.stop();
		swiper_work_02.autoplay.stop();
		swiper_work_context_01.autoplay.start();
		swiper_work_context_02.autoplay.start();
	}else{
		swiper_work_context_01.autoplay.stop();
		swiper_work_context_02.autoplay.stop();
		swiper_work_01.autoplay.start();
		swiper_work_02.autoplay.start();
	}


}
$('#work-controler-context').on('click',work_swiper_context_toggler );


function work_form_toggler(){
	body.toggleClass("work-form-toggler-open");
}
$('#work-form-panel').on('click', work_form_toggler);


function work_form_mobile_toggler(){
	body.toggleClass("work-form-mobile-toggler-open");
}
$('#work-inquire-mobile').on('click',work_form_mobile_toggler );


function work_form_toggler_close(){
	body.removeClass("work-form-toggler-open");
	body.removeClass("work-form-mobile-toggler-open");
}
$('.work-panel-close-toggler').on('click', work_form_toggler_close);




/******************************************
	About page
******************************************/

function open_about_panel(){
	body.addClass("about-panel-open");
}
$('.about-panel').on('mouseenter', open_about_panel);

function close_about_panel(){
	body.removeClass("about-panel-open");
}
$('.about-panel').on('mouseleave', close_about_panel);

function close_about_panel_click(){
	body.toggleClass("about-panel-open");
}
$('.about-panel').on('click', close_about_panel_click);



/******************************************
	archive post listing
	hover effect
******************************************/


$(".col-more-posts").on('mouseover', function() {
    $('.col-more-posts').not(this).addClass('hide');
});

$(".col-more-posts").on('mouseout', function() {
    $('.col-more-posts').not(this).removeClass('hide');
});



/******************************************
	Swiper
******************************************/


let $lgSwiper = document.getElementById('lg-swipper-01');
var optionSwiper01 = {
	// other parameters
	speed: 1000,
	loop: true,
	allowTouchMove: false,
	slidesPerView: 1,


	// navigation: {
	// 	nextEl: '.swiper-button-next',
	// 	prevEl: '.swiper-button-prev',
	// },

	// Init lightGallery ince swiper is initilized
	on: {
		init: function () {
			const lg = lightGallery($lgSwiper, {
				plugins: [lgZoom, lgFullscreen],
			});

			// Before closing lightGallery, make sure swiper slide
			// is aligned with the lightGallery active slide
			$lgSwiper.addEventListener('lgBeforeClose', () => {
				swiper_work_01.slideTo(lg.index, 0)
			});
		},
	}
};
 const swiper_work_01 = new Swiper('.swiper-work-01', optionSwiper01);


let $lgSwiper02 = document.getElementById('lg-swipper-02');
const swiper_work_02 = new Swiper('.swiper-work-02', {
	speed: 1000,
	loop: true,
	allowTouchMove: true,
	slidesPerView: 1,
	autoplay: {
		delay: 4500,
		disableOnInteraction: true,
	},

	controller: {
	    inverse: false,
	    control: swiper_work_01,
	},

	// Init lightGallery ince swiper is initilized
	on: {
		init: function () {
			const lg = lightGallery($lgSwiper02, {
				plugins: [lgZoom, lgFullscreen],
			});

			// Before closing lightGallery, make sure swiper slide
			// is aligned with the lightGallery active slide
			$lgSwiper02.addEventListener('lgBeforeClose', () => {
				swiper_work_02.slideTo(lg.index, 0)
			});
		},
	}

});

$('#work-slide-next').on('click', function(){
	swiper_work_02.slideNext();
})
$('#work-slide-previous').on('click', function(){
	swiper_work_02.slidePrev();
})


// lightGallery(document.getElementById('lg-container-2'), {
// 	download: false,
// });



const swiper_work_context_01 = new Swiper('.swiper-work-context-01', {
	speed: 1000,
	loop: true,
	allowTouchMove: false,
	slidesPerView: 1,
});

const swiper_work_context_02 = new Swiper('.swiper-work-context-02', {
	speed: 1000,
	loop: true,
	allowTouchMove: true,
	slidesPerView: 1,
	autoplay: {
		delay: 4500,
		disableOnInteraction: true,
	},

	controller: {
	    inverse: false,
	    control: swiper_work_context_01,
	},
});

$('#work-slide-context-next').on('click', function(){
	swiper_work_context_02.slideNext();
})
$('#work-slide-context-previous').on('click', function(){
	swiper_work_context_02.slidePrev();
})



const swiper_work_details_mobile = new Swiper('.swiper-work-details-mobile', {
	speed: 1000,
	autoHeight: true,
	loop: true,
	allowTouchMove: true,
	slidesPerView: 1,
	spaceBetween: 30,
});

var context_initialise = false;
$('#in-context-tab').on('shown.bs.tab', function (event) {
	if(!context_initialise){
		const swiper_work_context_mobile = new Swiper('.swiper-work-context-mobile', {
			speed: 1000,
			autoHeight: true,
			loop: true,
			allowTouchMove: true,
			slidesPerView: 1,
			spaceBetween: 30,
		});
		context_initialise = true;
	}
})




const swiper_blog = new Swiper('.swiper-blog', {
  loop: true,
  slidesPerView: 1,
  centeredSlides: true,
  autoHeight: true,

  // Navigation arrows
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },

  breakpoints: {
	    576: {
	      slidesPerView: 'auto',
		  autoHeight: false
	    }
   	}


});




/******************************************
	AOS
******************************************/

// You can also pass an optional settings object
// below listed default settings
AOS.init({
	// Global settings:
	disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
	startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
	initClassName: 'aos-init', // class applied after initialization
	animatedClassName: 'aos-animate', // class applied on animation
	useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
	disableMutationObserver: false, // disables automatic mutations' detections (advanced)
	debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
	throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)


	// Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
	offset: 75, // offset (in px) from the original trigger point
	delay: 0, // values from 0 to 3000, with step 50ms
	duration: 800, // values from 0 to 3000, with step 50ms
	easing: 'ease', // default easing for AOS animations
	once: false, // whether animation should happen only once - while scrolling down
	mirror: false, // whether elements should animate out while scrolling past them
	anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation

});




/******************************************
	Smooth scroll to anchor
******************************************/

// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
      &&
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top
        }, 1000, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });



//JQuery end
});
